export var USER_TOKEN = "token";
export var USER_DATA = "views";
export var LANGUAGE_CODE = "language";
export var DASHBOARD_REPORT_DATA = 'dashboard_report_data';
export var CURRENT_MENU_ITEM = 'current_menu_item';
export var USER_INFO_KEY = 'user_info';
export var CURRENT_WIDGET = 'current_widget';
export var CURRENT_MEDIA = 'current_media';
export var PUBLISHERS_KEY = 'publishers';
export var PUBLISHERS_WITHOUT_FILTER_KEY = 'publishers_without_filter';
export var PUBLISHERS_WITH_FILTER_KEY = 'publishers_with_filter';
export var PUBLISHER_MEDIAN_SELECTED_INVENTORIES = 'median_selected_inventories';
export var ALERT_KEY = 'alert_detail_info';
export var PUBDESK_INVENTORIES_SELECTED = 'pubdesk_inventory_selected';
export var COMPOSE_PUBDESK_INVENTORIES_SELECTED = 'compose_pubdesk_inventory_selected';
export var COMPOSE_PLATFORMS_SELECTED = 'compose_platform_selected';
export var TREND_PUBDESK_INVENTORIES_SELECTED = 'trend_pubdesk_inventory_selected';
export var SELECTED_PUBLISHERS_REPORT_KEY = 'selected_publishers_report';
export var LAST_REPORT_SETTING = 'last_report_setting';
export var LAST_SEEN_ANNOUNCEMENT = 'last_seen_announcement';
export var storeItem = function (key, data) {
    localStorage.setItem(key, data);
};
export var removeItem = function (key) {
    localStorage.removeItem(key);
};
export var getItem = function (key) {
    return localStorage.getItem(key);
};
